module.exports = __webpack_public_path__ + "static/media/jero.5225ceed.jpg";